import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'unistore/preact';
import i18n from 'micro-i18n';
import Loader from 'components/loader/Loader';
import { actions } from 'actions';

const FinishLoader = ({ questionsData, resultResponseCount, getFinish }) => {

  //componentDidUpdate() questionsData and resultResponseCount
  useEffect(() => {
    //NOTE: Due to async nature of getResults and back button addition, resultResponseCount could possibly be
    // greater than the questionsData.sessionLength due to possible race condition if the getResults hits the catch.
    questionsData && questionsData.questions && resultResponseCount >= questionsData.sessionLength && getFinish();
  }, [questionsData, resultResponseCount]);

  return (
    <Loader loaderMessage={i18n.t('CALCULATING_RESULTS')} isAnimated={true}/>
  );
};

FinishLoader.propTypes /* remove-proptypes */ = {
  questionsData: PropTypes.object,
  resultResponseCount: PropTypes.number,
  getFinish: PropTypes.func,
};

export default connect(
  'questionsData,resultResponseCount',
  actions
)(FinishLoader);
